/* ***************************************************************** */
/*                                                                   */
/* Licensed Materials - Property of IBM                              */
/*                                                                   */
/* (C) Copyright IBM Corp. 2022                                      */
/*                                                                   */
/* ***************************************************************** */
import React, { Component } from 'react';
import { connect } from "react-redux";
import queryString from 'query-string';
import { userService } from "../../services";
import { makeSetAuthenticationStateAction } from "../LoginPage/login-page-redux";
import { account_data, trackAccountEvents, trackAuthSuccess } from "../../utils/analytics-tracker-utils";

/**
 * Landing route for the Microsoft Entra callback redirect. The proxy establishes the session
 * and redirects here with a `sessionId` handle; this page exchanges that handle for the
 * subscription JSON, rebuilds the authentication state and forwards the user into the app.
 */
export class EntraCompletePagePresentation extends Component {

    failToLogin() {
        // Carry the failure reason via the URL itself (rather than a redux dispatch here)
        // so LoginPage can reliably set its own toast state on mount, with no dependency on
        // cross-component dispatch/navigation ordering.
        this.props.history.replace("/login?entraError=true");
    }

    componentDidMount() {
        const search = this.props.location ? this.props.location.search : '';
        const params = queryString.parse(search);

        if (params.error || !params.sessionId) {
            console.error("Entra login failed or missing sessionId.");
            this.failToLogin();
            return;
        }

        userService.getEntraSession(params.sessionId).then((jsonResponse) => {
            if (jsonResponse) {
                trackAccountEvents(jsonResponse);
                account_data(jsonResponse);
                trackAuthSuccess();
                this.props.onAuthenticated(jsonResponse);
                this.props.history.replace("/home");
            } else {
                this.failToLogin();
            }
        }).catch(() => this.failToLogin());
    }

    render() {
        return (
            <div className="Login">
                <div className="mdx-scroll-area">
                    <div className="mdx-login-content">
                        <p>Completing Microsoft Entra sign in…</p>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    onAuthenticated: (authenticationJson) => dispatch(makeSetAuthenticationStateAction(authenticationJson))
});

export default connect(null, mapDispatchToProps)(EntraCompletePagePresentation);
